import React from 'react';
import { Document } from '@roc/feature-types';
import { Tooltip } from '@roc/ui';
import { areActionsUnavailableBasedOnDocument, TASK_IN_PROGRESS_MESSAGE } from '@roc/feature-general-tasks';

export interface WithDocumentActionsProps {
  component: React.ComponentType<any>;
  document: Document;
  tooltipMessage?: string;
  [key: string]: any;
}

/**
 * Higher Order Component that wraps a component and disables it based on document actions availability.
 * If actions are unavailable (document is being processed), it adds disabled=true and wraps with a tooltip.
 *
 * @param props - Component props including the component to wrap and document object
 * @returns The wrapped component with conditional disabled state
 */
export const WithDocumentActions: React.FC<WithDocumentActionsProps> = ({
  component: Component,
  document,
  tooltipMessage = TASK_IN_PROGRESS_MESSAGE,
  ...restProps
}) => {
  const actionsUnavailable = areActionsUnavailableBasedOnDocument(document);

  if (actionsUnavailable) {
    return (
      <Tooltip title={tooltipMessage} placement="top">
        <span>
          <Component {...restProps} disabled={true} />
        </span>
      </Tooltip>
    );
  }

  return <Component {...restProps} />;
};

export default WithDocumentActions;
